<template>
  <div class="feedback-container">
    <h3>{{ $t('sorry-to-here-that-you-disliked-your-experience') }}</h3>
    <FriedTextarea
      :model-value="feedbackInput"
      class="feedback"
      :placeholder="$t('let-us-know-what-we-can-improve')"
      @update:modelValue="handleFeedback"
    ></FriedTextarea>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue';

export default defineComponent({
  setup(_props, { emit }) {
    const feedbackInput = ref('');

    const handleFeedback = () => {
      emit('feedback', feedbackInput.value);
    };

    return {
      feedbackInput,
      handleFeedback,
    };
  },
});
</script>
<style lang="scss" scoped>
.feedback-container {
  display: flex;
  width: 100%;
  flex-direction: column;
  text-align: center;

  .feedback {
    width: auto;
    height: 6rem;
    margin: 0;
    resize: none;

    @media screen and (max-width: $sm) {
      height: 3rem;
    }
  }
}
</style>
